import React from 'react';
import './vcard.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Utils from '../../utils/Utils';
import { playFullMedia } from '../../actions/playmedia';
import { setResumeData } from '../../actions/resume';
import { showModal, MODAL_LANGUAGES, MODAL_ERROR } from '../../actions/modal';
import EpisodeSelection from '../EpisodeSelection/index';

import Button from '../Button';
import Ribbon from '../Ribbon';
import Scrollable from '../Scrollable';
import Translator from '../../requests/apa/Translator';
import * as api from '../../requests/loader';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';

import favoriteDelTask from '../../requests/tasks/ficha/favoriteDelTask';
import favoriteTask from '../../requests/tasks/ficha/favoriteTask';
import RequestManager from '../../requests/RequestManager';
import { updateFavorite, deleteFavorite } from '../../reducers/user';
import { setMetricsEvent } from '../../actions/metrics';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Device from '../../devices/device';
import settings from '../../devices/all/settings';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import store from '../../store';
import { showNotification } from '../../actions/notification';
import { UserSeenLast } from '../../requests/loader';
import { setLastTouchFavorited, setLastTouchSeen } from './../../reducers/user';
import EventEmitter from '../../utils/EventEmitter';
import { getTalents, getExternalTalents, getSeasonId, getFormatTypes } from './fichaHelper';
import { LetsPlayCatchup } from '../PersistentMiniEpg/MiniObserver';
import LayersControl from '../../utils/LayersControl';
import {
  AAFPLAYER_STOP
} from '../../AAFPlayer/constants';

const config_remote_control =
  DeviceStorage.getItem('config_remote_control') !== 'simple' ? true : false;

class NewFicha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      roles: [],
      externalrole: null,
      recommendations: [],
      serieData: {
        seasons: [],
        seasonNumber: null,
        episodeNumber: null
      }
    };
    this.provider_id = false;
    this.groupId = '';
    this.contentId = '';
    this.recommendations = [];
    this.tooglePlay = false;
    this.isTrailer = false;
    this.languages = [];
    this.keys = Device.getDevice().getKeys();
    this.action = () => {};
    this.isFavouriteButtonVisible = false;
    this.isPlayTrailerButtonVisible = false;
    this.toggleFunctions = Utils.getToggleFunctionsFromMetadata(); // utils to get specific toggle functions
    this.isFavorited = false; // flag to know if the content is favorited
    this.lenguageData = [];
  }

  // Display vcard stuff
  loadContent = async (groupId, ignoreSeenLast = false) => {
    this.clearPBIandRecommendations();
    console.log('[FICHA] loadContent groupId:', groupId);
    if (!this.isValidGroupId(groupId)) return;
    const contentData = await this.getContentData(groupId);
    if (!contentData) return;
    if(contentData && contentData.group &&
      contentData.group.common && contentData.group.common.extendedcommon &&
      contentData.group.common.extendedcommon.media && contentData.group.common.extendedcommon.media.language &&
      contentData.group.common.extendedcommon.media.language.options && contentData.group.common.extendedcommon.media.language.options.option){
      this.lenguageData = contentData.group.common.extendedcommon.media.language.options.option;
    }
    const seasonId = getSeasonId(contentData);
    const isSerie = !!seasonId;
    let bookmark;
    if (!this.isAnonymous()) {
      if (isSerie && !ignoreSeenLast) {
        const seenLast = await UserSeenLast(groupId);
        const groupIdToRedirect = this.getGroupIdToRedirect(seenLast);
        if (groupIdToRedirect && groupIdToRedirect !== groupId) {
          console.log('[FICHA] lets change content: ', groupIdToRedirect);
          return this.changeContent(groupIdToRedirect);
        }
      }
      const { favorited, bookmark: bookmarkResolved } = await this.getFavoritedAndBookmark(
        groupId
      );
      bookmark = bookmarkResolved;
    }
    this.groupId = groupId;
    const { roles, externalrole } = this.getRoles(contentData);
    if (isSerie) {
      this.asyncLoadSerieContent(contentData);
      this.updateResume(
        contentData,
        bookmark,
      );
      this.updateState(roles, externalrole);
    } else {
      this.updateResume(contentData, bookmark);
      this.updateState(roles, externalrole);
    }
    this.asyncLoadRecommendations(groupId);
  };

  asyncLoadSerieContent(contentData){
    this.getSerieData(contentData).then(({ seasonsText, serieData })=>{
      this.props.setResumeData({
        seasonsText
      })
      this.setState({serieData});
    });
  }

  clearPBIandRecommendations(){
    this.props.setResumeData({
      recommendations:[],
      playButton: null,
      purchaseButtonInfo: null,
      seasonsText: null
    });
    this.setState({
      serieData: []
    });
  }

  asyncLoadRecommendations(groupId){
    api.contentRecomendations({groupId}).then(recommendations => {
      this.recommendations = recommendations;
      this.setState({
        recommendations: recommendations ? recommendations : []
      });
      this.props.setResumeData({
        recommendations
      });
    });
  }

  asyncLoadPurchaseButtonInfo(groupId){
    //TODO setear this.seasonId
    const request = this.seasonId
      ? api.PurchaseButtonInfov585({ groupId, seasonId:this.seasonId })
      : api.PurchaseButtonInfov585({ groupId });
    request.then(purchaseButtonInfo=>{
      this.updatePurchaseButtonInfoInResume(purchaseButtonInfo);
      this.sendYoubora(purchaseButtonInfo);
    }).catch(err=>{
      console.log('[NewFicha] asyncLoadPurchaseButtonInfo catch err',err);
    });
  }

  updatePurchaseButtonInfoInResume(purchaseButtonInfo){
    const isPlayButtonVisible =
      purchaseButtonInfo &&
      purchaseButtonInfo.playButton &&
      purchaseButtonInfo.playButton.visible === '1';
    this.isTrailer = !isPlayButtonVisible;
    this.isPlayTrailerButtonVisible = this.getPlayTrailerButtonVisibility(
      isPlayButtonVisible,
      this.hasPreview
    );
    const playButton = this.getPlayButton({
      isPlayButtonVisible: isPlayButtonVisible,
      hasPreview: this.hasPreview,
      handlePlay: this.handlePlay,
      episode: this.episode && this.episode.number,
      season: this.episode && this.episode.season
    });
    this.props.setResumeData({
      playButton: playButton,
      purchaseButtonInfo
    });
    if (Utils.isModalHide()) {
      window.SpatialNavigation.focus('.elementopredeterminado');
    }
  }

  updateState = (roles, externalrole) => {
    this.setState({
      isFetching: false,
      roles,
      externalrole,
    });
    this.setScrollTop();
    this.focusDefaultElement();
  };

  updateBookmark = async groupId => {
    if (this.isAnonymous()) return;
    const { time: time_progress, progress, image_frames } = await this.getBookmark(groupId);
    if (time_progress != '00:00:00' && image_frames !== '') {
      const previewImage = Utils.getImageFrame(image_frames, time_progress);
      const frameImage = previewImage;
      this.props.setResumeData({
        previewImage,
        frameImage,
        progress,
        time_progress
      });
    }
  };

  updateResume = async (
    contentData,
    bookmark,
  ) => {
    const {
      group: {
        common: {
          id: groupId,
          image_small = '',
          title = '',
          description = '',
          image_still = '',
          image_frames = '',
          image_sprites = '',
          duration = '',
          extendedcommon = {}
        } = {}
      } = {}
    } = contentData;
    const {
      genres: { genre: genreArray = [] } = {},
      media = {},
      format: { types = '' } = {}
    } = extendedcommon;
    const {
      publishyear: year = '',
      rating: { code: ratingCode = '' } = {},
      haspreview = '',
      language: { options: { option: languageArray } = {} } = {},
      proveedor: { nombre: providerName } = {},
      serie: { title: serieTitle = '' } = {},
      episode = null,
      serieseason = null
    } = media;
    const titleToDisplay = serieTitle ? `${serieTitle} : ${title}` : title;
    let progress = 0;
    let time_progress = '00:00:00';
    const format_types = getFormatTypes(contentData);
    const hasPreview = haspreview == 'true';
    this.hasPreview = hasPreview;
    this.episode = episode;
    this.seasonId = serieseason && serieseason.id || null;
    // this.hasPreview && this.episode this.seasonId se usa para actualizar boton play y pbi
    this.asyncLoadPurchaseButtonInfo(groupId);
    let previewImage = image_still;
    let frameImage = image_frames;
    const spriteImage = image_sprites;
    const genresText = genreArray
      .slice(0, 3)
      .map(genre => genre.desc)
      .join(', ');
    const defaultLang = DeviceStorage.getItem('default_lang');
    const lang = languageArray.find(language => language.option_id == defaultLang);

    // send google analitics metric
    this.sendVirtualPage(types, genreArray, titleToDisplay);
    // calculamos bookmark para usuario que no es anonimo
    if (!this.isAnonymous()) {
      const { time, image_frames } = bookmark;
      progress = bookmark.progress;
      if (time != '00:00:00' && image_frames !== '') {
        time_progress = time;
        progress = progress;
        previewImage = Utils.getImageFrame(image_frames, time_progress);
        frameImage = previewImage;
      }
    }

    // esto no se que fixea
    const player = store.getState().player;
    let type = null;
    if (player.playerstate === 'STOPPING') {
      type = 'vod';
    }
    const langButton = this.getLangButton();
    const favoritedButton = this.getFavouriteButton(this.isFavorited);
    this.content = {
      title: titleToDisplay,
      serieTitle,
      image_still,
      image_frames
    };

    this.languages = languageArray;
    this.contentId = lang ? lang.content_id : '';
    this.favoriteData = {
      id: groupId,
      title,
      image_small,
      format_types,
      proveedor_name: providerName
    };
    this.props.setResumeData({
      type,
      title: titleToDisplay,
      year,
      description,
      rating: ratingCode,
      category: genresText,
      duration: duration ? Utils.formatDuration(duration) : '',
      image_small,
      previewImage,
      frameImage,
      spriteImage,
      showBack: false,
      groupId,
      progress,
      time_progress,
      lastEpisode: null,
      showActionBtns: true,
      isSeason: !!episode,
      langButton: langButton,
      favouriteButton: favoritedButton,
      isBack: false,
      isLive: false,
      format_types,
      provider: providerName
    });
  };
  /**
   * this method is executed when player send a custom event in order to update the bookmark of content
   */
  handleUpdateProgress = async evnt => {
    let groupId = '';
    if (evnt && evnt.detail && evnt.detail.videoid) {
      groupId = evnt.detail.videoid;
      this.updateBookmark(groupId);
    }
  };

  getFavouriteButton = (status_button = false) => {
    if (this.isAnonymous()) {
      this.isFavouriteButtonVisible = false;
      return null;
    }
    this.isFavouriteButtonVisible = true;
    const buttonIcon = status_button ? 'fa-minus' : 'fa-plus';
    this.action = status_button ? this.deleteFavorite : this.addToFavorite;
    return (
      <Button
        text={Translator.get('grupo_button_addFan', 'Mi lista')}
        iconClassName={`fa ${buttonIcon}`}
        colorCode={config_remote_control ? 'yellow' : null}
        onClick={this.action}
      />
    );
  };

  getLangButton = () => {
    return (
      <Button
        text={Translator.get('ficha_lang_label', 'Idioma')}
        iconClassName={'fa fa-comment'}
        colorCode={config_remote_control ? 'green' : null}
        onClick={() => this.showLanguages()}
      />
    );
  };

  getPlayButton = ({ isPlayButtonVisible, hasPreview, handlePlay, episode, season }) => {
    let playText = Translator.get('detail_play', 'Ver ahora');
    const trailerButton = hasPreview ? (
      <Button
        className="elementopredeterminado"
        text={Translator.get('btn_trailer', 'Trailer')}
        iconClassName={'fa fa-film'}
        colorCode={config_remote_control ? 'blue' : null}
        onClick={() => {
          handlePlay(!isPlayButtonVisible);
        }}
      />
    ) : null;

    return isPlayButtonVisible ? (
      <Button
        className="elementopredeterminado"
        text={playText}
        iconClassName={'fa fa-play'}
        colorCode={config_remote_control ? 'blue' : null}
        onClick={() => {
          handlePlay(!isPlayButtonVisible);
        }}
      />
    ) : (
      trailerButton
    );
  };

  // Vcard actions
  back = () => {

    // si está player visible, con error de reproducción, solo se muestra la ficha nuevamente
    if (LayersControl.isPlayerVisible() && AAFPlayer.getCurrentPlayingState(false) === AAFPLAYER_STOP) {
      LayersControl.hidePlayer(true);
      return;
    }

    this.props.history.goBack();
    setTimeout(() => {
      if (window.location.href.indexOf('/vcard') !== -1) {
        const pathname = window.location.pathname.split('/');
        const goGroupIdBack = pathname[2] ? pathname[2] : '';
        this.replaceContent(goGroupIdBack);
      }
    }, 100);
  };

  handleEpisodeClick = (episode, changeVcard = true) => {
    this.sendMetric('cambiar episodio', episode.title_episode);
    this.changeContent(episode.id);
  };

  handleKeyPress = e => {
    const playerIsPlayingInPip = AAFPlayer.livePlayingAsPip();
    if (AAFPlayer.playerOptions) {
      if (AAFPlayer.playerOptions.playerstate && !playerIsPlayingInPip) return;
    } else if (!Utils.isModalHide()) {
      return;
    }

    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    console.log('Listening Ficha, currentKey', currentKey);
    switch (currentKey) {
      case 'BLUE':
        e.preventDefault();
        e.stopPropagation();
        if (this.isPlayTrailerButtonVisible) this.handlePlay(this.isTrailer);
        break;
      case 'SUB_AUD':
      case 'GREEN':
        e.preventDefault();
        e.stopPropagation();
        this.showLanguages(this.languages);
        break;
      case 'YELLOW':
        e.preventDefault();
        e.stopPropagation();
        if (this.isFavouriteButtonVisible) this.action(e);
        break;
      case 'UP':
        this.scrollVertical(0);
        break;
      case 'DOWN':
        this.scrollVertical(null);
        break;
      case 'BACK':
        e.preventDefault();
        e.stopPropagation();
        this.back();
        break;
      default:
        break;
    }
  };

  handleTalentClick = talent => {
    const { history } = this.props;
    history.push(`/talent/${talent.id}/${talent.fullname}/${this.provider_id}`);
  };

  addToFavorite = event => {
    this.sendMetric('agregar a mi lista');
    event.preventDefault();
    const p = {
      object_id: this.groupId,
      object_type: 1,
      user_hash: this.props.user.session_userhash
    };

    let params = new favoriteTask(p);
    RequestManager.addRequest(params)
      .then(data => {
        // Actualizar favoritos y seen con el mismo valor de favorited
        if (data.lasttouch && data.lasttouch.favorited) {
          const lastTouchFav = data.lasttouch.favorited;
          store.dispatch(setLastTouchSeen(lastTouchFav));
          store.dispatch(setLastTouchFavorited(lastTouchFav));
        }
        this.props.updateFavorite(this.favoriteData);
        if (data.response) {
          let message = Translator.get(
            'add_favorite_message',
            'Se agrego, {title} a mis favoritos.'
          );
          message = message.replace('{title}', this.content.title);
          this.props.showNotification({
            show: true,
            title: message,
            faClass: 'fa-plus',
            type: 'message'
          });
          this.props.setResumeData({ favouriteButton: this.getFavouriteButton(true) });
        }
      })
      .catch(e => {
        this.setState({ visible: null });
        const modal = {
          modalType: MODAL_ERROR,
          modalProps: {
            content: e
          }
        };
        this.props.showModal(modal);
      });
  };

  deleteFavorite = event => {
    this.sendMetric('quitar de mi lista');
    event.preventDefault();
    const p = {
      object_id: this.groupId,
      object_type: 1,
      user_hash: this.props.user ? this.props.user.session_userhash : null
    };
    let params = new favoriteDelTask(p);
    RequestManager.addRequest(params)
      .then(data => {
        this.props.deleteFavorite(this.groupId);
        if (data.response) {
          // Actualizar favoritos y seen con el mismo valor de favorited (para que lo tome level-user)
          if (data.lasttouch && data.lasttouch.favorited) {
            const lastTouchFav = data.lasttouch.favorited;
            store.dispatch(setLastTouchSeen(lastTouchFav));
            store.dispatch(setLastTouchFavorited(lastTouchFav));
          }
          let message = Translator.get(
            'delete_favorite_message',
            'Se removió, {title} de mis favoritos.'
          );
          message = message.replace('{title}', this.content.title);
          this.props.showNotification({
            show: true,
            title: message,
            faClass: 'fa-minus',
            type: 'message'
          });
          this.props.setResumeData({ favouriteButton: this.getFavouriteButton(false) });
        }
      })
      .catch(e => {
        const modal = {
          modalType: MODAL_ERROR,
          modalProps: {
            content: e
          }
        };
        this.props.showModal(modal);
      });
  };

  // Playing content stuff

  handlePlay = (isTrailer = false) => {
    LetsPlayCatchup.fire();
    if (isTrailer) this.sendMetric(Translator.get('btn_trailer', 'Trailer'));
    else this.sendMetric(Translator.get('detail_play', 'Ver ahora'));
    this.sendToPlay();
  };

  sendToPlay = () => {
    this.tooglePlay = !this.tooglePlay;
    const resume = store.getState().resume;
    const payway_token =
      resume &&
      resume.purchaseButtonInfo &&
      resume.purchaseButtonInfo.playButton &&
      resume.purchaseButtonInfo.playButton.payway_token
        ? resume.purchaseButtonInfo.playButton.payway_token
        : null;
    if (this.isValidGroupId(this.groupId)) {
      this.props.playFullMedia({
        payway_token,
        playerstate: 'PLAYING',
        source: {
          videoid: this.groupId,
          seasonid: this.seasonId ? this.seasonId : null
        },
        size: {
          top: 0,
          left: 0,
          width: 1280,
          height: 720
        },
        ispreview: this.isTrailer,
        islive: false,
        ispip: false,
        recommendations: this.recommendations,
        tooglePlay: this.tooglePlay,
        event: null,
        languageoptions: this.lenguageData
      });
    }
  };

  // Helpers
  isValidGroupId = groupId => {
    const regex = new RegExp('^[0-9]+$');
    return regex.test(groupId);
  };

  focusDefaultElement = () => {
    //Solo pasa el foco a la ficha si no hay alguna ventana modal activa
    if (Utils.isModalHide()) {
      window.SpatialNavigation.focus('main_container');
    }
  };

  getPlayTrailerButtonVisibility = (isPlayButtonVisible, hasPreview) =>
    isPlayButtonVisible || hasPreview;

  resolveContentTalent = (universal_id, external) => {
    let resolveKey = JSON.stringify({
      default: {
        enabled: true,
        provider: 'gracenote'
      }
    });
    resolveKey = Utils.getApaMetadataKey('external_metadata', resolveKey);
    const providerTalent = resolveKey.enabled === true ? resolveKey.provider : null;
    let externalTalents = null;
    if (resolveKey) {
      if (
        providerTalent &&
        universal_id &&
        universal_id['metadata_providers'] &&
        universal_id['metadata_providers'][providerTalent]
      ) {
        // Verificar si viene el array de talentos
        this.provider_id =
          universal_id['metadata_providers'][providerTalent]['provider_id'];
        const arrTalent = external[providerTalent] && external[providerTalent]['cast'];
        if (arrTalent) {
          externalTalents = getExternalTalents(
            external[providerTalent]['cast'],
            this.handleTalentClick
          );
        }
      }
    }

    return externalTalents;
  };

  scrollVertical = value => {
    /*Scrollea el div scroller-container verticalmente deacuerdo al valor recivido como parametro*/
    //Esto solo aplica para Hisense
    if (Utils.isHisense()) {
      const scrollContainer =
        document.getElementsByClassName('scroller-container') &&
        document.getElementsByClassName('scroller-container')[0]
          ? document.getElementsByClassName('scroller-container')[0]
          : null;
      const activeElement = document.activeElement;

      if (
        scrollContainer &&
        activeElement.pathname &&
        activeElement.pathname.includes('/socialProfile/')
      ) {
        const scrollTop = value === null ? scrollContainer.scrollHeight : value;
        scrollContainer.scrollTop = scrollTop;
      }
    }
  };

  setScrollTop = () => {
    const scrollContainer =
      document.getElementsByClassName('scroller-container') &&
      document.getElementsByClassName('scroller-container')[0]
        ? document.getElementsByClassName('scroller-container')[0]
        : null;
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  };

  showLanguages = () => {
    const modal = {
      modalType: MODAL_LANGUAGES,
      modalProps: {
        languages: this.languages,
        callback: this.setLanguage
      }
    };

    if (this.languages.length > 0) this.props.showModal(modal);
    else this.showError('No languages');
  };

  showError = (message, callback = () => {}) => {
    const modal = {
      modalType: MODAL_ERROR,
      modalProps: {
        callback,
        content: { message }
      }
    };
    this.props.showModal(modal);
  };

  setLanguage = language => {
    DeviceStorage.setItem('default_lang', language.option_id);
    this.contentId = language.content_id;
    this.sendMetric('idioma', language.label_short);
  };

  isAnonymous = () => this.props.user && this.props.user.isAnonymous;

  getGroupIdToRedirect = seenLast =>
    seenLast && seenLast.episode && seenLast.episode.id ? seenLast.episode.id : null;

  replaceContent = groupId => {
    if (groupId !== this.groupId) {
      this.props.history.replace(`/vcard/${groupId}`);
      this.loadContent(groupId);
    }
  };

  changeContent = groupId => {
    if (groupId !== this.groupId) {
      this.props.history.replace(`/vcard/${groupId}`);
      this.loadContent(groupId, true);
    }
  };

  pushContent = groupId => {
    if (groupId !== this.groupId) {
      this.props.history.push(`/vcard/${groupId}`);
      this.loadContent(groupId);
    }
  };

  checkFavoritedContent = async groupId => {
    const filterList = Utils.getAPAFilterList();
    const favs = await api.fetchFavoriteLoader(this.props.user, filterList);
    if (
      favs &&
      favs.response &&
      favs.response &&
      favs.response.groups &&
      Array.isArray(favs.response.groups)
    ) {
      const favoritedContent = favs.response.groups.find(el => el.id == groupId);
      this.isFavorited = favoritedContent && typeof favoritedContent == 'object';
    }
    return new Promise(resolve => resolve(true));
  };

  getRoles = contentData => {
    const {
      group: {
        common: { extendedcommon: { roles: { role: roleArray = [] } = {} } = {} } = {},
        universal_id = null,
        external = null
      } = {}
    } = contentData;
    const externalrole = this.resolveContentTalent(universal_id, external);

    return { externalrole, roles: roleArray };
  };

  getSerieData = async contentData => {
    try {
      const {
        group: {
          common: {
            id: groupId,
            extendedcommon: {
              media: { episode: { season = '', number = '' } } = null
            } = {}
          } = {}
        } = {}
      } = contentData;
      const contentSerie = await api.contentSerie(groupId);
      const { seasons = [] } = contentSerie;
      const seasonsText =
        seasons.length > 0
          ? seasons.length === 1
            ? `1 ${Translator.get('season', 'Temporada')}`
            : `${seasons.length} ${Translator.get('season', 'Temporada')}s`
          : null;
      return new Promise(resolve =>
        resolve({
          seasonsText,
          serieData: {
            groupId,
            seasons,
            seasonNumber: season,
            episodeNumber: number
          }
        })
      );
    } catch (e) {
      return new Promise(resolve =>
        resolve({
          seasonsText: '',
          serieData: null
        })
      );
    }
  };

  getBookmark = async groupId => {
    if (this.isAnonymous())
      return new Promise(resolve =>
        resolve({ time: '00:00:00', progress: 0, image_still: '', image_frames: '' })
      );
    try {
      const bookmark = await api.getBookmark(groupId);
      const { response: { groups = [] } = {} } = bookmark;
      const [firstBookmark = {}] = groups;
      const {
        image_still = '',
        image_frames = '',
        vistime: { last: { time = '00:00:00', progress = 0 } = {} } = {}
      } = firstBookmark;
      return new Promise(resolve => resolve({ time, progress, image_still, image_frames }));
    } catch (e) {
      return new Promise(resolve =>
        resolve({ time: '00:00:00', progress: 0, image_still: '', image_frames: '' })
      );
    }
  };

  getFavoritedAndBookmark = async groupId => {
    let favorited, bookmark;
    try {
      const [favoritedResolved, bookmarkResolved] = await Promise.all([
        this.checkFavoritedContent(groupId),
        this.getBookmark(groupId)
      ]);
      favorited = favoritedResolved;
      bookmark = bookmarkResolved;
    } catch (e) {
      (favorited = favorited ? favorited : null), (bookmark = bookmark ? bookmark : null);
    }
    return new Promise(resolve => resolve({ favorited, bookmark }));
  };

  getContentData = async groupId => {
    let contentData;
    try {
      contentData = await api.contentData(groupId);
    } catch (e) {
      this.lenguageData = [];
      contentData = null;
    }
    return new Promise(resolve => resolve(contentData));
  };

  //  metric stuff
  sendDimension = () => {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  };

  sendVirtualPage = (types, genreArray, title) => {
    if (typeof this.props.setMetricsEvent === 'function') {
      const genresText = genreArray.map(genre => genre.desc).join(',');
      this.props.setMetricsEvent({
        hitType: 'pageview',
        page: `vCard/${types}-${genresText}-${title}`
      });
      this.props.setMetricsEvent({ type: 'executor' });
    }
  };

  sendMetric = (action, label = null) => {
    if (typeof this.props.setMetricsEvent === 'function') {
      if (action === 'cambiar episodio') {
        let [serieTitle = ''] = this.content.title.split(':');
        label = `${serieTitle} - ${label}`;
      } else {
        if (label !== null) label = `${label} - ${this.content.title}`;
        else label = `${this.content.title}`;
      }
      this.props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'vcard',
        eventAction: action,
        eventLabel: label
      });
      this.props.setMetricsEvent({ type: 'executor' });
      this.sendDimension();
    }
  };

  sendYoubora = purchaseButtonInfo => {
    // Youbora: Se setea el parametro window.youboraParams[5] cuando paymentmethod en linealChannels viene null
    if (
      window.youboraParams[5].value !== null &&
      purchaseButtonInfo.playButton &&
      purchaseButtonInfo.playButton &&
      purchaseButtonInfo.playButton.paymentmethod &&
      purchaseButtonInfo.playButton.paymentmethod.gateway
    ) {
      window.youboraParams[5].value = purchaseButtonInfo.playButton.paymentmethod.gateway;
    }
    // Youbora: Se setea el Tipo de abono para youboraParams[2] cuando el tipo de contenido es VOD en caso de que sea trailer no manda el parametro
    if (purchaseButtonInfo.playButton)
      window.youboraParams[2].value = purchaseButtonInfo.playButton.key;
  };

  // Component life-cycle methods
  componentDidMount() {
    document.removeEventListener('keydown', this.handleKeyPress, true);
    document.addEventListener('keydown', this.handleKeyPress, true);
    document.removeEventListener(settings.update_progress, this.handleUpdateProgress);
    document.addEventListener(settings.update_progress, this.handleUpdateProgress);
    const match = this.props.match;
    const groupId = match.params.groupId;
    let ignoreSeenLast = !!match.params.ignoreSeenLast;
    this.loadContent(groupId, ignoreSeenLast);
    EventEmitter.on('player:episodeChange', ({ groupId }) => {
      this.changeContent(groupId);
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    //TODO improve this using a shallow comparison
    return JSON.stringify(this.state) !== JSON.stringify(nextState);
  }

  componentWillUnmount() {
    document.removeEventListener(settings.update_progress, this.handleUpdateProgress);
    document.removeEventListener('keydown', this.handleKeyPress, true);
  }

  render() {
    console.log('[Ficha] render');
    if (this.state.isFetching) {
      return null;
    }
    const { serieData, recommendations, roles, externalrole } = this.state;
    const talents = externalrole ? externalrole : getTalents(roles, this.handleTalentClick);
    //FIX https://dlatvarg.atlassian.net/browse/STV-6698
    const scrolleableHeight = Utils.isHisense() ? 370 : 410;
    return (
      <Scrollable height={scrolleableHeight}>
        {serieData && serieData.seasons && serieData.seasons.length > 0 ? (
          <EpisodeSelection
            data={serieData}
            handleEpisodeClick={this.handleEpisodeClick}
            setMetricsEvent={this.props.setMetricsEvent}
            dataMetric={this.content.title}
            handlePlay={this.handlePlay}
            getPlayButton={this.getPlayButton}
          />
        ) : null}

        <div className="vcard-talents">
          {talents.length > 0 && this.toggleFunctions.talents ? (
            <Ribbon
              type={'user-profile'}
              title={Translator.get(
                'predictSearch_talents_label',
                'Talentos Relacionados:'
              )}
              items={talents}
              visibleNumber={talents.length < 12 ? talents.length : 12}
              setMetricsEvent={this.props.setMetricsEvent}
              carruselTitle={'Talentos Relacionados:'}
            />
          ) : null}
        </div>

        <div className="vcard-recommendations">
          {recommendations.length > 0 && this.toggleFunctions.recommendations ? (
            <Ribbon
              user={this.props.user}
              title={Translator.get(
                'SeeOther',
                'Otros usuarios que vieron este contenido tambien vieron:'
              )}
              type="landscape"
              items={recommendations.map(r => {
                return {
                  id: r.id,
                  title: r.title,
                  group_id: r.id,
                  cover: r.image_small,
                  proveedor_name: r.proveedor_name,
                  provider:
                    r.proveedor_name == 'AMCO' ? 'default' : r.proveedor_name,
                  format_types: r.format_types.split(','),
                  live_enabled: r.live_enabled,
                  type: r.live_enabled === '1' ? 'live' : 'vod',
                  clickHandler: () => {
                    this.pushContent(r.id);
                  }
                };
              })}
              setMetricsEvent={this.props.setMetricsEvent}
              carruselTitle={Translator.get(
                'SeeOther',
                'Otros usuarios que vieron este contenido tambien vieron:'
              )}
            />
          ) : null}
        </div>
      </Scrollable>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      playFullMedia,
      setResumeData,
      showModal,
      updateFavorite,
      deleteFavorite,
      setMetricsEvent,
      showNotification
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(NewFicha);



// WEBPACK FOOTER //
// ./src/components/Ficha/NewFicha.jsx